import React, { useState, useEffect } from 'react';
import useKeydownAndClick from '@/hooks/useKeydownAndClick';
import Icon from '@/components/ui/Icon';
import styles from './Collapse.module.scss';
import cn from '@/utils/cn';

interface CollapseProps {
  triggerElement?: JSX.Element;
  children?: React.ReactNode;
  shouldCollapse?: boolean;
}

const Collapse = ({
  triggerElement,
  children,
  shouldCollapse,
}: CollapseProps) => {
  const [expanded, setExpanded] = useState(!shouldCollapse);

  useEffect(() => {
    setExpanded(!shouldCollapse);
  }, [shouldCollapse]);

  const isHeader = triggerElement?.type === 'h1';
  const iconDimensions = isHeader ? 24 : 16;

  return (
    <>
      <div
        className={cn(styles.collapseContainer, 'body xs')}
        role="button"
        tabIndex={0}
        {...useKeydownAndClick(() => setExpanded(!expanded))}
      >
        {triggerElement}

        <div className={styles.collapseIcon}>
          {expanded
            ? (<Icon height={iconDimensions} icon="ChevronUp" width={iconDimensions} />)
            : (<Icon height={iconDimensions} icon="ChevronDown" width={iconDimensions} />)}
        </div>
      </div>

      <div
        className={`${styles.collapsible} ${expanded ? '' : styles.collapsed}`}
      >
        {children}
      </div>
    </>
  );
};

export default Collapse;
